export default function () {
  return {
    downloads: {},
    loading: false,
  }
}
